export const ANALYTICS_BATCH_MAX_EVENTS = 20;
export const ANALYTICS_BATCH_MAX_BYTES = 48 * 1024;
export const ANALYTICS_FLUSH_DELAY_MS = 2000;
